export const Loading = () => <div className="AtLoaderWrapper"><span className="loader"></span></div>
